export function TimelineIcon() {
  return (
    <svg viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <rect x="25" y="22" width="30" height="14" rx="4" fill="currentColor" />
      <rect x="42" y="43" width="40" height="14" rx="4" fill="currentColor" />
      <rect x="25" y="64" width="22" height="14" rx="4" fill="currentColor" />
    </svg>
  );
}
